import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/landing/SupportV2.tsx");
